var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomecare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "80px",
    width: "80px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 401.138 401.138",
    xmlSpace: "preserve",
    fill: "#2b7afe",
    stroke: "#2b7afe",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e11f09"
    },
    d: "M98.795,226.834c10.987-6.978,18.286-19.227,18.286-33.205c0-21.745-17.628-39.368-39.368-39.368 c-21.745,0-39.373,17.623-39.373,39.368c0,13.978,7.31,26.227,18.286,33.205C23.959,236.021,0,266.017,0,301.622 c0,42.92,155.416,42.92,155.416,0C155.416,266.017,131.462,236.026,98.795,226.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e11f09"
    },
    d: "M397.862,221.134l-75.152-75.152V96.417c0-6.173-5.004-11.188-11.194-11.188 c-6.179,0-11.183,5.015-11.183,11.188v27.195l-53.02-53.009c-4.362-4.368-11.444-4.368-15.8,0l-75.298,75.298 c6.429,4.047,11.607,9.85,14.876,16.752l68.331-68.336l142.645,142.639c2.17,2.176,5.042,3.28,7.898,3.28 c2.85,0,5.727-1.088,7.903-3.28C402.23,232.573,402.23,225.496,397.862,221.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e11f09"
    },
    d: "M365.88,233.965L247.336,115.421c-2.105-2.105-4.939-3.285-7.903-3.285s-5.803,1.18-7.903,3.285 l-57.235,57.23c0.408,2.274,0.658,4.612,0.658,7c0,5.118-0.968,10.089-2.785,14.68c16.051,11.672,26.173,30.606,26.173,51.225 c0,7.19-3.236,23.437-30.47,31.275c2.197,7.957,3.383,16.274,3.383,24.797c0,11.792-5.586,21.033-14.615,28.153h37.638 c7.49,0,14.718-3.166,19.831-8.703c4.645-5.015,7.201-11.525,7.201-18.335v-42.49c0-10.312,7.903-18.923,18.112-19.896 c10.209,0.974,18.112,9.589,18.112,19.896v42.49c0,6.81,2.562,13.32,7.196,18.335c5.102,5.537,12.33,8.703,19.831,8.703h57.866 c14.892,0,27.027-12.124,27.027-27.038v-57.866c0-1.692-0.158-3.41-0.5-5.118C368.529,237.555,367.463,235.548,365.88,233.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e11f09"
    },
    d: "M113.921,224.044c17.726,8.284,31.867,22.436,40.418,39.613 c15.79-2.633,28.163-8.659,28.163-18.101c0-21.724-14.62-40.026-34.554-45.639c6.701-4.27,11.166-11.738,11.166-20.271 c0-13.266-10.764-24.019-24.024-24.019c-7.99,0-15.044,3.911-19.412,9.899c5.836,7.87,9.333,17.568,9.333,28.087 C125.006,204.953,121.008,215.641,113.921,224.044z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomecare);
export default __webpack_public_path__ + "static/media/homecare.c072500538ccc47ec176024f85698058.svg";
export { ForwardRef as ReactComponent };